<template>
    <div class="contenedor">
        <b-card class="contenedor">
        <div slot="header">
            <strong>
              <center style="font-size:12pt;">Iconos</center>
            </strong>
        </div>
        <b-row>
         <b-col sm="12" md="12" lg="12">
          <center>
            <b-form-group middle :label-cols="5" breakpoint="md"></b-form-group>            
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col>
                    <center>
                      <b>Protección Ocular</b>
                    </center>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <img class="navbar-brand-minimized"  src="img/Epps/Ocular_1.jpg" width="46" height="46"  alt="Logo-soluquim"/>
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_ocular.ocular1"
                      name="ocular1"
                      @change="handleChangeOcular($event)"
                    />
                  </b-col>
                  <b-col sm="4">
                    <img class="navbar-brand-minimized"  src="img/Epps/Ocular_2.jpg" width="46" height="46"  alt="Logo-soluquim"/>
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_ocular.ocular2"
                      name="ocular2"
                      @change="handleChangeOcular($event)"
                    />
                  </b-col>
                  <b-col sm="4">
                    <img class="navbar-brand-minimized"  src="img/Epps/Ocular_3.jpg" width="46" height="46"  alt="Logo-soluquim"/>
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_ocular.ocular3"
                      name="ocular3"
                      @change="handleChangeOcular($event)"
                    />
                  </b-col>
                </b-row>
              </b-col>              
              <b-col sm="12">
                <b-row>
                  <b-col>
                    <center>
                      <b>Protección Cutánea</b>
                    </center>
                  </b-col>
                  <b-col sm="12">
                    <img class="navbar-brand-minimized"  src="img/Epps/Guantes.jpg" width="46" height="46"  alt="Logo-soluquim"/>
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_cutanea.cutanea1"
                      name="cutanea1"
                      @change="handleChangeCutanea($event)"
                    />
                  </b-col>
                </b-row>
              </b-col>              

              <b-col sm="12">
                <b-row>
                  <b-col>
                    <center>
                      <b>Protección Respiratoria</b>
                    </center>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <img class="navbar-brand-minimized"  src="img/Epps/Respiratorio_1.jpg" width="46" height="46"  alt="Logo-soluquim"/>
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_respiratoria.respiratoria1"
                      name="respiratoria1"
                      @change="handleChangeRespiratoria($event)"
                    />
                  </b-col>                
                  <b-col sm="4">
                    <img class="navbar-brand-minimized"  src="img/Epps/Respiratorio_2.jpg" width="46" height="46"  alt="Logo-soluquim"/>
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_respiratoria.respiratoria2"
                      name="respiratoria2"
                      @change="handleChangeRespiratoria($event)"
                    />
                  </b-col>                
                  <b-col sm="4">
                    <img class="navbar-brand-minimized"  src="img/Epps/Respiratorio_3.jpg" width="46" height="46"  alt="Logo-soluquim"/>
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_respiratoria.respiratoria3"
                      name="respiratoria3"
                      @change="handleChangeRespiratoria($event)"
                    />
                  </b-col>                
                  <b-col sm="4">
                    <img class="navbar-brand-minimized" src="img/Epps/Respiratorio_4.jpg" width="46" height="46" alt="Logo-soluquim" />
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_respiratoria.respiratoria4"
                      name="respiratoria4"
                      @change="handleChangeRespiratoria($event)"
                    />
                  </b-col>
                </b-row>
              </b-col>              
              <b-col sm="12">
                <b-row>
                  <b-col>
                    <center>
                      <b>Botas/Calzado</b>
                    </center>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <img class="navbar-brand-minimized"  src="img/Epps/Calzado.jpg" width="46" height="46"  alt="Logo-soluquim"/>
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_calzado.calzado1"
                      name="calzado1"
                      @change="handleChangeCalzado($event)"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12">
                <b-row>
                  <b-col>
                    <center>
                      <b>Traje/Ropa</b>
                    </center>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="6">
                    <img  class="navbar-brand-minimized"  src="img/Epps/Traje_1.jpg" width="46" height="46" alt="Logo-soluquim" />
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_ropa.ropa1"
                      name="ropa1"
                      @change="handleChangeRopa($event)"
                    />
                  </b-col>
                  <b-col sm="6">
                    <img
                      class="navbar-brand-minimized"  src="img/Epps/Traje_2.jpg" width="46" height="46"  alt="Logo-soluquim"/>
                    <input
                      type="checkbox"
                      :disabled="disabledInputs"
                      style="width:24px;height:24px;"
                      v-model="selectedEpp.layer_ropa.ropa2"
                      name="ropa2"
                      @change="handleChangeRopa($event)"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </center>
        </b-col>
                
            </b-row>

            <br />
        </b-card>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
export default {
    name:'Epps',
    data: function(){
        return{
            mostrar_ocular: false,
            agrega_ocular:true,
            mostrar_cutanea: false,
            agrega_cutanea:true,
            mostrar_respiratoria: false,
            agrega_respiratoria:true,
            mostrar_calzado: false,
            agrega_calzado:true,
            mostrar_ropa: false,
            agrega_ropa:true
        };
    },
    created(){

    },
    computed: {
      disabledInputs() {
        return this.selectedProductEt.finalizado == 0 ? false : true
      }, 
    ...mapState("epps_et", [
      "selectedEpp",
      "iconos",
      "lista_ocular",
      "lista_cutanea",
      "lista_respiratoria",
      "lista_calzado",
      "lista_ropa"
    ]),
    ...mapState('productos_et',[
      'selectedProductEt'
    ])
  },
  methods: {
    ...mapActions("epps_et", [
      "guardaEpp",
      "guardaEppDescrito",
      "guardaIcosEpp",
      "eliminaEppDescrito"
    ]),
    agregarOcular: function() {
      //alert("Agrega Ocular");
      this.mostrar_ocular = !this.mostrar_ocular;
      this.agrega_ocular = false;
      
    },

    ocultaOcular: function() {
      this.mostrar_ocular = false;
      this.agrega_ocular = true;
    },

    agregarCutanea: function() {
      //alert("Agrega Cutanea");
      this.mostrar_cutanea = !this.mostrar_cutanea;
      this.agrega_cutanea = false;
    },

    ocultaCutanea: function() {
      this.mostrar_cutanea = false;
      this.agrega_cutanea = true;
    },

    agregarRespiratoria: function() {
      //alert("Agrega Respiratoria");
      this.mostrar_respiratoria = !this.mostrar_respiratoria;
      this.agrega_respiratoria = false;
    },

    ocultaRespiratoria: function() {
      this.mostrar_respiratoria = false;
      this.agrega_respiratoria = true;
    },

    agregarCalzado: function() {
      //alert("Agrega Calzado");
      this.mostrar_calzado = !this.mostrar_calzado;
      this.agrega_calzado = false;
    },

    ocultaCalzado: function() {
      this.mostrar_calzado = false;
      this.agrega_calzado = true;
    },

    agregarRopa: function() {
      //alert("Agrega Ropa");
      this.mostrar_ropa = !this.mostrar_ropa;
      this.agrega_ropa = false;
    },

    ocultaRopa: function() {
      this.mostrar_ropa = false;
      this.agrega_ropa = true;
    },
    handleChangeOcular: function(e) {
      this.selectedEpp.tipo = 1;
      const name = e.target.name;
      if (this.selectedEpp.layer_ocular[name]) {
        Object.keys(this.selectedEpp.layer_ocular).map(key => {
          if (key != name) {
            this.selectedEpp.layer_ocular[key] = false;
          }
        });
      }
      this.guardaIcosEpp(this.selectedEpp.layer_ocular);
    },
    handleChangeCutanea: function(e) {
      this.selectedEpp.tipo = 2;
      const name = e.target.name;
      if (this.selectedEpp.layer_cutanea[name]) {
        Object.keys(this.selectedEpp.layer_cutanea).map(key => {
          if (key != name) {
            this.selectedEpp.layer_cutanea[key] = false;
          }
        });
      }
      this.guardaIcosEpp(this.selectedEpp.layer_cutanea);
    },
    handleChangeRespiratoria: function(e) {
      this.selectedEpp.tipo = 3;
      const name = e.target.name;
      if (this.selectedEpp.layer_respiratoria[name]) {
        Object.keys(this.selectedEpp.layer_respiratoria).map(key => {
          if (key != name) {
            this.selectedEpp.layer_respiratoria[key] = false;
          }
        });
      }
      this.guardaIcosEpp(this.selectedEpp.layer_respiratoria);
    },
    handleChangeCalzado: function(e) {
      this.selectedEpp.tipo = 4;
      const name = e.target.name;
      if (this.selectedEpp.layer_calzado[name]) {
        Object.keys(this.selectedEpp.layer_calzado).map(key => {
          if (key != name) {
            this.selectedEpp.layer_calzado[key] = false;
          }
        });
      }
      this.guardaIcosEpp(this.selectedEpp.layer_calzado);
    },
    handleChangeRopa: function(e) {
      this.selectedEpp.tipo = 5;
      const name = e.target.name;
      if (this.selectedEpp.layer_ropa[name]) {
        Object.keys(this.selectedEpp.layer_ropa).map(key => {
          if (key != name) {
            this.selectedEpp.layer_ropa[key] = false;
          }
        });
      }
      this.guardaIcosEpp(this.selectedEpp.layer_ropa);
    }
  }
    
}
</script>